import React from 'react'
import Notifications from '../shared/Notifications'
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { getUserInfo } from "../../apis/General/users";

function EfficiencyHeader() {



  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);

  const [modalOpen, setModalOpen] = useState(false);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  const handleModalOpen = () => setModalOpen(true);
  const handleModalClose = () => setModalOpen(false);

  
  const [kycStatus, setKycStatus] = useState("");
  const [notifications1, setStaticNotifications] = useState([]);
  const [notifications2, setFirebaseNotifications] = useState([]);



  
  const  fetchUserInfo = async () => {
    const  response = await getUserInfo(auth?.userInfo?.id, auth?.token);
    console.log("getUserInfo", response);
    setFirstName(response?.data?.message?.firstName);
    setLastName(response?.data?.message?.lastName);
  };


  // console.log('mice', localStorage.getItem('kycCompleted') === "complete");

  useEffect(() => {
    fetchUserInfo();
  }, []);
  return (
    <div>
      
      <div className="search_flex">
        <div className="notification pointer" onClick={handleModalOpen}>
          {notifications1?.length > 0 || notifications2?.length > 0 ? (
            <svg
              className="badge"
              width="7"
              height="6"
              viewBox="0 0 7 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.5 6C5.15685 6 6.5 4.65685 6.5 3C6.5 1.34315 5.15685 0 3.5 0C1.84315 0 0.5 1.34315 0.5 3C0.5 4.65685 1.84315 6 3.5 6Z"
                fill="#D42620"
              />
            </svg>
          ) : (
            ""
          )}
          {notifications1?.length < 1 && notifications2?.length < 1 ? (
            <svg
              className="badge"
              width="7"
              height="6"
              viewBox="0 0 7 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.5 6C5.15685 6 6.5 4.65685 6.5 3C6.5 1.34315 5.15685 0 3.5 0C1.84315 0 0.5 1.34315 0.5 3C0.5 4.65685 1.84315 6 3.5 6Z"
                fill="#667185"
              />
            </svg>
          ) : (
            ""
          )}

          <svg
            width="20"
            height="23"
            viewBox="0 0 20 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.5 12.4395V10.5H16V12.75C16 12.9489 16.0791 13.1396 16.2197 13.2803L18.25 15.3105V16.5H1.75V15.3105L3.78025 13.2803C3.92091 13.1396 3.99996 12.9489 4 12.75V9.75C3.99791 8.6961 4.27398 7.6603 4.80032 6.74724C5.32665 5.83417 6.08463 5.07618 6.99767 4.5498C7.91072 4.02343 8.9465 3.74733 10.0004 3.74938C11.0543 3.75144 12.089 4.03157 13 4.5615V2.88525C12.2861 2.56914 11.5267 2.36766 10.75 2.28825V0.75H9.25V2.2875C7.40093 2.4757 5.68732 3.34284 4.44053 4.72124C3.19373 6.09964 2.50233 7.89138 2.5 9.75V12.4395L0.46975 14.4697C0.329088 14.6104 0.250042 14.8011 0.25 15V17.25C0.25 17.4489 0.329018 17.6397 0.46967 17.7803C0.610322 17.921 0.801088 18 1 18H6.25V18.75C6.25 19.7446 6.64509 20.6984 7.34835 21.4016C8.05161 22.1049 9.00544 22.5 10 22.5C10.9946 22.5 11.9484 22.1049 12.6517 21.4016C13.3549 20.6984 13.75 19.7446 13.75 18.75V18H19C19.1989 18 19.3897 17.921 19.5303 17.7803C19.671 17.6397 19.75 17.4489 19.75 17.25V15C19.75 14.8011 19.6709 14.6104 19.5303 14.4697L17.5 12.4395ZM12.25 18.75C12.25 19.3467 12.0129 19.919 11.591 20.341C11.169 20.7629 10.5967 21 10 21C9.40326 21 8.83097 20.7629 8.40901 20.341C7.98705 19.919 7.75 19.3467 7.75 18.75V18H12.25V18.75Z"
              fill="#667185"
            />
          </svg>
        </div>
        <div
          className="profile"
          onClick={() => {
            navigate("/profile");
            window.scrollTo(0, 0);
          }}
        >
          <div className="search_name">
            {firstName?.split("")[0]}
            {lastName?.split("")[0]}
            <svg
              className="kyc_svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.0758 2.14075C13.31 2.14075 13.5 1.935 13.5 1.68225V0.95825C13.5 0.705 13.31 0.5 13.0758 0.5H2.92425C2.68975 0.5 2.5 0.705 2.5 0.95825V1.68225C2.5 1.935 2.68975 2.1405 2.92425 2.1405H3.1875V13.8593H2.92425C2.68975 13.8593 2.5 14.0642 2.5 14.3175V15.0413C2.5 15.2945 2.68975 15.5 2.92425 15.5H13.0755C13.31 15.5 13.5 15.2945 13.5 15.0413V14.3175C13.5 14.0642 13.31 13.8593 13.0758 13.8593H12.8125V2.14075H13.0758ZM3.64575 13.8595V2.14075H4.07675C3.9655 2.14075 3.875 2.2245 3.875 2.328V2.8905C3.875 2.994 3.9645 3.07725 4.0755 3.078C4.0755 5.15025 4.4075 7.16425 6.8085 7.85825L6.927 7.89575C7.03075 7.92875 7.155 7.96775 7.2185 8C7.155 8.03175 7.03225 8.07075 6.929 8.10325L6.81575 8.1395C4.40775 8.836 4.07575 10.8498 4.07575 12.922C3.965 12.9227 3.87525 13.0063 3.87525 13.1093V13.6718C3.87525 13.7753 3.9655 13.8595 4.077 13.8595H3.64575ZM8.9365 8.55125L9.06 8.59025C10.7615 9.08225 11.4257 10.2015 11.4642 12.6875H8.204C8.17125 11.5315 8.08925 8.57925 8.08925 8C8.08925 7.80375 8.45225 7.5285 8.61925 7.43025C9.324 7.014 10.2305 6.1905 10.2305 5.3335H5.769C5.769 6.1905 6.6755 7.014 7.38025 7.43025C7.54675 7.52875 7.91025 7.80375 7.91025 8C7.91025 8.5945 7.8285 11.5345 7.79575 12.6875H4.53575C4.574 10.2022 5.239 9.0825 6.947 8.58825L7.06425 8.5515C7.3925 8.448 7.7025 8.35 7.7025 8.00025C7.7025 7.65 7.3915 7.55175 7.06175 7.44825L6.93975 7.4095C5.2385 6.9175 4.57425 5.7985 4.536 3.31275H11.4648C11.4263 5.7985 10.7615 6.91825 9.054 7.41175L8.93975 7.448C8.60975 7.5515 8.298 7.64975 8.298 8.00025C8.2975 8.34975 8.608 8.44775 8.9365 8.55125ZM12.354 13.8595H11.9235C12.0345 13.8595 12.125 13.7753 12.125 13.6718V13.1093C12.125 13.006 12.035 12.9227 11.9242 12.9222C11.9242 10.8497 11.5922 8.8355 9.19125 8.1415L9.07125 8.1035C8.96825 8.071 8.845 8.032 8.7815 8.00025C8.84525 7.968 8.96975 7.929 9.07375 7.896L9.1845 7.86075C11.5922 7.16475 11.9242 5.15075 11.9242 3.07825C12.0347 3.07775 12.125 2.99425 12.125 2.8905V2.328C12.125 2.2245 12.0347 2.14075 11.9235 2.14075H12.354V13.8595Z"
                fill={
                  kycStatus === "pending"
                    ? "#00AED9"
                    : kycStatus === "completed"
                    ? "#0F973D"
                    : ""
                }
              />
            </svg>
            {kycStatus === "pending" ? (
              <div className="tag tag_progress">
                KYC Validation <br /> confirmation in progress
              </div>
            ) : kycStatus === "completed" ? (
              <div className="tag">
                KYC Validation <br /> confirmation completed
              </div>
            ) : (
              ""
            )}
          </div>

          <div className="profile_title">Profile</div>
        </div>
      </div>


      {modalOpen && <Notifications handleModalClose={handleModalClose} />}

    </div>
  )
}

export default EfficiencyHeader
